import { Component, ContentChildren, OnInit, Input, ViewEncapsulation, QueryList } from '@angular/core';
import { AD_SUPPORT, AtSupport } from '../directives/support.directive';

export type CheckTheme = 'primary' | 'secondary' | 'tertiary' | 'magenta' | 'orange' | 'purple' | 'red' | 'teal' | 'yellow' | 'gray';

@Component({
  selector: 'at-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  host: {
    'class': 'at-form-field-checkbox',
    '[class.at-checkbox-button-primary]': 'theme === "primary"',
    '[class.at-checkbox-button-secondary]': 'theme === "secondary"',
    '[class.at-checkbox-button-tertiary]': 'theme === "tertiary"',
    '[class.at-checkbox-button-magenta]': 'theme === "magenta"',
    '[class.at-checkbox-button-orange]': 'theme === "orange"',
    '[class.at-checkbox-button-purple]': 'theme === "purple"',
    '[class.at-checkbox-button-red]': 'theme === "red"',
    '[class.at-checkbox-button-teal]': 'theme === "teal"',
    '[class.at-checkbox-button-yellow]': 'theme === "yellow"',
    '[class.at-checkbox-button-gray]': 'theme === "gray"'
  },
  encapsulation: ViewEncapsulation.None
})
export class CheckboxComponent implements OnInit {

  @ContentChildren(AD_SUPPORT, {descendants: true}) _supportChildren: QueryList<AtSupport>;

  @Input()
  get theme(): CheckTheme { return this._theme; }
  set theme(value: CheckTheme) {
    this._theme = value || 'primary';
  }
  _theme: CheckTheme;

  constructor() { }

  ngOnInit() {
  }

}
